<template>
  <div class="user-info">
    <div class="user-head">
        <div class="head-left">
            <div class="user-img">
                <span v-if="userInfo.username">{{userInfo.username.length>2?userInfo.username.slice(0,2):userInfo.username}}</span>
            </div>
            <div class="user-text">
                <div class="user-text-name">{{userInfo.username}}</div>
                <div class="user-text-identity">{{getStarLevel(userInfo.star_score)}}</div>
            </div>
        </div>
        <div class="head-right" @click="on_logout">
            退出登录
        </div>
    </div>
    <div class="user-content">
        <div class="user-content-num">{{userInfo.ore_count}}</div>
        <div class="user-tip">
          <span>段位星 {{userInfo.star_score}}</span>
          <span>战力值 {{userInfo.score}}</span>
          <span v-if="userInfo.fans_medal_level != 0">粉丝牌等级 {{userInfo.fans_medal_level}}</span>
        </div>
        <div>
          <span class="user-content-text" @click="on_enter_jilu">兑换记录</span>
          <span class="user-content-text" @click="on_enter_daoju">我的道具</span>
          <span class="user-content-text" @click="on_enter_rank">赛季天梯</span>
        </div>
    </div>
  </div>
</template>

<script>
import { get } from './../../../utils/httpService'
export default {
  name: 'user-info',
  data () {
    return {
      isLogin: true,
      userInfo: {
        name: '哈哈哈哈哈哈哈哈哈',
        headImg: '',
        identity: '团长',
        caikuangNum: 1200
      },
      starConfig: [
        {
          level: 10,
          name: '司令',
          star: 3000
        },
        {
          level: 9,
          name: '军长',
          star: 2300
        },
        {
          level: 8,
          name: '师长',
          star: 1700
        },
        {
          level: 7,
          name: '旅长',
          star: 1200
        },
        {
          level: 6,
          name: '团长',
          star: 800
        },
        {
          level: 5,
          name: '营长',
          star: 500
        },
        {
          level: 4,
          name: '连长',
          star: 300
        },
        {
          level: 3,
          name: '排长',
          star: 150
        },
        {
          level: 2,
          name: '班长',
          star: 50
        },
        {
          level: 1,
          name: '新兵',
          star: 0
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        this.userInfo = await get('/api/user/info')
        this.$emit('userInfoFnc', this.userInfo)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    getStarLevel (starNum) {
      for (let i in this.starConfig) {
        if (starNum >= this.starConfig[i].star) {
          return this.starConfig[i].name
        }
      }
    },
    on_enter_jilu () {
      this.$router.push({
        path: 'record'
        // query: {userid: 1}
      })
    },
    on_enter_daoju () {
      this.$router.push({
        path: 'prop'
        // query: {userid: 1}
      })
    },
    on_enter_rank () {
      this.$router.push({
        path: 'ranking'
        // query: {userid: 1}
      })
    },
    on_logout () {
      localStorage.removeItem('utoken')
      console.log('aaa', localStorage.getItem('utoken'))
      this.$router.push({
        path: 'login'
      })
    }
  }
}
</script>

<style>
.user-info{background: #000;color: #fff;padding: 0.22rem;}
.user-head{display: flex;justify-content: space-between;}
.head-left{display: flex;}
.user-img{width: 0.8rem;height: 0.8rem;background: #eee;border-radius: 50%;display: flex;align-items: center;justify-content: center;}
.user-img span{max-height: 100%;color: #000;font-size: 0.3rem;display: flex;}
.user-text{margin-left: 0.2rem;height: 0.8rem;display: flex;flex-direction: column;justify-content: space-between;}
.user-text .user-text-name{font-size: 0.3rem;overflow: hidden;white-space: nowrap; overflow: hidden;text-overflow: ellipsis;width: 4rem;}
.user-text .user-text-identity{font-size: 0.26rem;color: #eee;}
.head-right{font-size: 0.26rem;cursor: pointer;}
.user-content{text-align: center;padding: 0.4rem 0;}
.user-content-num{font-size: 1rem;}
.user-content-text{font-size: 0.26rem;padding: 0.09rem 0.4rem;border:1px solid #fff;border-radius: 0.5rem;cursor: pointer;}
.user-tip{font-size: 0.22rem;color: #bbb;}
.user-tip span{padding:  0.1rem;}
</style>



// WEBPACK FOOTER //
// src/view/home/components/userInfo.vue